import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Offcanvas, UIKits } from "../../../Constants/Constants";
import OffcanvasDirections from "./OffcanvasDirections/OffcanvasDirections";
import OffcanvasVariations from "./OffcanvasVariations/OffcanvasVariations";

const OffcanvasContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Offcanvas} parent={UIKits} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <OffcanvasDirections />
            <OffcanvasVariations />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default OffcanvasContainer;
